import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import { EmojiButton } from "@joeattardi/emoji-button";
import { RichTextEditorIconEnum } from "@webapp/shared/rich-text-editor/rich-text-editor-icon/rich-text-editor-icon.enum";

export type EmojiPickerMenuPosition = "top" | "middle" | "bottom";

@Component({
  selector: "emoji-picker",
  templateUrl: "./emoji-picker.component.html",
  styleUrls: ["./emoji-picker.component.less"],
  encapsulation: ViewEncapsulation.None,
})
export class EmojiPickerComponent implements OnInit {
  @Input() public outOfFocus: boolean;

  @Output() public selectedEmoji = new EventEmitter<string>();
  @Output() public open = new EventEmitter<MouseEvent>();
  @Output() public close = new EventEmitter<MouseEvent>();

  @ViewChild("emojiPickerContainer") public emojiPickerContainer: ElementRef;

  public showEmojiPickerPolygon: boolean;
  public emojiPickerPosition: EmojiPickerMenuPosition;
  public staticMenuPosition: EmojiPickerMenuPosition;
  public emojiIcon = RichTextEditorIconEnum.EMOJI;

  private emojiPicker: EmojiButton;

  constructor(private elementRef: ElementRef) {}

  public ngOnInit(): void {
    this.showEmojiPickerPolygon = false;
  }

  @HostListener("document:click", ["$event"])
  public clickedOutsideOfModalListener(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event?.target) && this.showEmojiPickerPolygon) {
      this.closeEmojiPickerModal(event);
    }
  }

  public toggleEmojiPicker(event: MouseEvent): void {
    // Create the Emoji Button only if it is needed, not on every component initialization, because it is an expensive DOM operation
    if (!this.emojiPicker) {
      this.createEmojiPicker();
    }

    this.emojiPicker.togglePicker(event.currentTarget as HTMLElement);

    this.emojiPickerPosition = this.staticMenuPosition || this.getMenuPosition();
    this.showEmojiPickerPolygon = !this.showEmojiPickerPolygon;

    if (this.showEmojiPickerPolygon) {
      this.open.emit(event);
    }
  }

  public closeEmojiPickerModal(event?: MouseEvent): void {
    this.emojiPicker.hidePicker();
    this.showEmojiPickerPolygon = false;

    this.close.emit(event);
  }

  public createEmojiPicker(): void {
    this.emojiPicker = new EmojiButton({ rootElement: this.emojiPickerContainer?.nativeElement, showAnimation: false, autoFocusSearch: false });
    this.emojiPicker.on("emoji", (selection) => {
      this.selectedEmoji.emit(selection.emoji);
      this.closeEmojiPickerModal();
    });
  }

  private getMenuPosition = (): EmojiPickerMenuPosition => {
    const addGifElemTopOffset = this.elementRef.nativeElement.getBoundingClientRect().top;
    const availableHeightBot = window.screen.availHeight - addGifElemTopOffset;

    if (availableHeightBot > 700) {
      return "top";
    } else if (availableHeightBot > 500) {
      return "middle";
    } else {
      return "bottom";
    }
  };
}
